"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _mediaQuery = require("@kiwicom/orbit-components/lib/utils/mediaQuery");
var _js = require("@adeira/js");
var _Theme = require("../../../records/Theme");
var _useWithMediaQuery = _interopRequireDefault(require("../../../services/utils/useWithMediaQuery"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Media__Wrapper",
  componentId: "sc-1r2vbch-0"
})(({
  greaterThanOrEqual,
  lessThan,
  displayValue,
  theme
}) => {
  if (greaterThanOrEqual != null) {
    return {
      display: "none",
      [`@media${(0, _mediaQuery.getBreakpointWidth)(greaterThanOrEqual, theme)}`]: {
        display: displayValue
      }
    };
  }
  if (lessThan != null) {
    return {
      display: displayValue,
      [`@media${(0, _mediaQuery.getBreakpointWidth)(lessThan, theme)}`]: {
        display: "none"
      }
    };
  }
  return null;
});
Wrapper.defaultProps = {
  theme: _Theme.themeDefault
};
const Media = ({
  displayValue = "block",
  children,
  greaterThanOrEqual,
  lessThan,
  dataTest
}) => {
  var _ref;
  const [shouldDisplay, setShouldDisplay] = React.useState(true);
  // Fallback to keep ts happy;
  const breakpoint = (_ref = greaterThanOrEqual !== null && greaterThanOrEqual !== void 0 ? greaterThanOrEqual : lessThan) !== null && _ref !== void 0 ? _ref : "tablet";
  process.env.NODE_ENV !== "production" ? (0, _js.warning)(!(greaterThanOrEqual == null && lessThan == null), "You should provide either greaterThanOrEqual or lessThan") : void 0;
  const callback = React.useCallback(matches => {
    if (greaterThanOrEqual != null) {
      setShouldDisplay(matches);
    } else if (lessThan != null) {
      setShouldDisplay(!matches);
    }
  }, [greaterThanOrEqual, lessThan]);
  (0, _useWithMediaQuery.default)({
    breakpoint,
    callback
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    "data-test": dataTest,
    lessThan: lessThan,
    greaterThanOrEqual: greaterThanOrEqual,
    displayValue: displayValue,
    children: shouldDisplay ? children : null
  });
};
var _default = Media;
exports.default = _default;